import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

interface MusicContextType {
  isPlaying: boolean;
  setIsPlaying: (value: boolean) => void;
  currentTime: number;
  setCurrentTime: (time: number) => void;
  fadeAndNavigate: (url: string) => void;
}

const MusicContext = createContext<MusicContextType | undefined>(undefined);

export const MusicProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(() => {
    const cachedMusic = localStorage.getItem('music');
    return cachedMusic === 'true';
  });

  const [currentTime, setCurrentTime] = useState(() => {
    const savedTime = localStorage.getItem('musicTime');
    return savedTime ? parseFloat(savedTime) : 0;
  });

  const fadeAndNavigate = useCallback((url: string) => {
    const audioElement = document.querySelector('audio');
    if (audioElement) {
      let volume = audioElement.volume;
      const fadeInterval = setInterval(() => {
        if (volume > 0.02) {
          volume = Math.max(volume - 0.02, 0);
          audioElement.volume = volume;
        } else {
          clearInterval(fadeInterval);
          window.location.href = url;
        }
      }, 50);
    } else {
      window.location.href = url;
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('music', isPlaying.toString());
  }, [isPlaying]);

  useEffect(() => {
    localStorage.setItem('musicTime', currentTime.toString());
  }, [currentTime]);

  return (
    <MusicContext.Provider value={{ 
      isPlaying, 
      setIsPlaying, 
      currentTime, 
      setCurrentTime,
      fadeAndNavigate 
    }}>
      {children}
    </MusicContext.Provider>
  );
};

export const useMusic = () => {
  const context = useContext(MusicContext);
  if (context === undefined) {
    throw new Error('useMusic должен использоваться внутри MusicProvider');
  }
  return context;
}; 